export default __webpack_public_path__ + "static/media/Camera.5ab674a1.svg";